import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin, Loader2, Search } from 'lucide-react';

interface Filters {
  type: string[];
  nearMe: boolean;
}

interface CommunityFiltersProps {
  filters: Filters;
  onFilterChange: (filterType: keyof Filters, values: string[] | boolean) => void;
  locationLoading?: boolean;
  searchQuery?: string;
  onSearchChange?: (value: string) => void;
}

export function CommunityFilters({ filters, onFilterChange, locationLoading, searchQuery = '', onSearchChange }: CommunityFiltersProps) {
  const { t } = useTranslation();
  return (
    <div className="border-b border-border/50 backdrop-blur-md bg-transparent w-full">
      <div className="px-3 sm:px-4 lg:px-6 max-w-page mx-auto">
        <div className="w-full overflow-x-auto scrollbar-hide">
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 py-3">
            {/* Search + Near Me row */}
            <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
              <div className="relative flex-1 min-w-0 max-w-md">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-content/40" />
                <input
                  type="text"
                  placeholder={t('communities.searchPlaceholder')}
                  value={searchQuery}
                  onChange={(e) => onSearchChange?.(e.target.value)}
                  className="w-full pl-9 pr-4 py-2.5 rounded-full border border-gray-200 bg-white text-content text-sm placeholder:text-content/40 focus:outline-none focus:ring-2 focus:ring-accent-text/20 focus:border-accent-text"
                />
              </div>
              <button
                onClick={() => onFilterChange('nearMe', !filters.nearMe)}
                disabled={locationLoading}
                className={`flex-shrink-0 h-10 px-4 rounded-full gap-2 inline-flex items-center text-sm font-medium transition-colors ${
                  filters.nearMe
                    ? 'bg-accent-text text-white shadow-sm'
                    : 'bg-gray-100 text-content hover:bg-gray-200'
                } ${locationLoading ? 'opacity-50 cursor-wait' : ''}`}
              >
                {locationLoading ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                  <MapPin className="h-4 w-4" />
                )}
                <span>{t('filters.nearMe')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
